// src/Dashboard/pages/user/DashboardUser/components/DashboardUserSectionShell.jsx

import React from "react";

export default function DashboardUserSectionShell({
  title,
  subtitle,
  icon: Icon,
  toolbar,
  children,
}) {
  return (
    <section className="overflow-hidden rounded-[28px] border border-slate-200 bg-white/80 shadow-sm backdrop-blur dark:border-slate-800 dark:bg-slate-900/70">
      <div className="relative overflow-hidden bg-gradient-to-r from-[#013E8E] via-indigo-600 to-[#0f5cc0] px-5 py-5 text-white sm:px-6">
        <div className="absolute inset-0 bg-[radial-gradient(circle_at_top_right,rgba(76,168,47,0.22),transparent_32%),radial-gradient(circle_at_bottom_left,rgba(255,255,255,0.18),transparent_30%)]" />

        <div className="relative flex flex-col gap-3 sm:flex-row sm:items-center sm:justify-between">
          <div className="flex items-start gap-3">
            {Icon && (
              <span className="mt-0.5 flex h-11 w-11 shrink-0 items-center justify-center rounded-2xl bg-white/15 text-white ring-1 ring-white/20">
                <Icon />
              </span>
            )}

            <div>
              <h2 className="text-lg font-bold sm:text-xl font-montserrat">
                {title}
              </h2>
              {subtitle && (
                <p className="mt-1 max-w-3xl text-sm leading-6 text-white/85">
                  {subtitle}
                </p>
              )}
            </div>
          </div>

          {toolbar}
        </div>
      </div>

      <div className="max-h-[72vh] min-h-[360px] overflow-y-auto p-4 sm:p-6">
        {children}
      </div>
    </section>
  );
}